<template>
  <UIDialog
    :is-open
    :z-index
    size="md"
    unclosable
    flat
    @close="handleClose"
  >
    <AppGlobalSearch
      v-model:search="search"
      v-model:current-tag="currentTag"
      :items-found
      :is-open
      :tags
      @result:click="handleClickResult"
    />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass, SearchSummary } from '@types'

import { useSearchStore } from '@/store/search'

import { useHotKeys } from '@/plugins/hotKeys'

import { AppGlobalSearch } from '@app'
import { UIDialog } from '@ui/modals'
import { useGlobalSearch } from '@/hooks/globalSearch'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()
const searchStore = useSearchStore()

const { handleSearchResult } = useGlobalSearch()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const search = computed({
  get() {
    return searchStore.string
  },
  set(value) {
    searchStore.string = value
  },
})

const currentTag = computed({
  get() {
    return searchStore.currentTag
  },
  set(value) {
    searchStore.currentTag = value
  },
})

const tags = computed(() => searchStore.tags)

const itemsFound = computed(() =>
  searchStore.string.trim() !== '' ? searchStore.getSearchSummary : [],
)

const handleClose = () => {
  props.modal.close()
}

const handleClickResult = async (item: SearchSummary) => {
  handleClose()
  handleSearchResult(item)
}

useHotKeys(
  'escape',
  handleClose,
  { priority: 10 },
)
</script>
